import React, {useEffect, useState} from 'react';
import TopTitleBlock from '../../Components/TopTitleBlock/TopTitleBlock';
import TopPageInfoBlock from '../../Components/TopPageInfoBlock/TopPageInfoBlock';
import s from './PaperworkList.module.css';
import style from '../CreationOfDesign/CreationOfDesign.module.css';
import styleTableGrid from '../ListOfProducts/ListOfProductsTableGrid/ListOfProductsTableGrid.module.css';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import VeryLightGreenButton from '../../Components/Buttons/VeryLightGreenButton';
import ButtonPlusElement from '../../Components/Buttons/ButtonPlusElement';
import LightGreenButton from '../../Components/Buttons/LightGreenButton';
import AddFilterButton from '../../Components/Buttons/AddFilterButton';
import PaperworkListTableElement from './components/PaperworkListTableElement';
import PaperWorkFilter from '../../Components/Filter/PaperWorkFilter';

import {useTranslation} from 'react-i18next';
import {
	FilterPaperworkButton,
	OrderInPaperworkType,
	RequestPaperworkListType,
} from '../../types/TypesDepotPaperwork';
import ShoppingTotal from '../../Components/ShoppingTotal/ShoppingTotal';
import GridTableHead from '../../Components/GridTableHead/GridTableHead';
import PaperworkFilterButtons from './components/PaperworkFilterButtons';
import {Form, Formik} from 'formik';
import {validationFilterForm} from '../../assets/utils/validation';
import {scrollToTop, submitFilterFieldCleaner} from '../../assets/utils/utils';
import PrroBlock from './components/PrroBlock/PrroBlock';
import {
	usePaperworkHistoryQuery,
	usePaperworkListQuery,
} from '../../redux/activitiesApi';
import PreLoaderComponent from '../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import HistoryOfChangesInvoice from '../ListOfInvoices/HistoryOfChangesInvoice';
import {todayDate, yesterdayDate} from '../../assets/utils/dateUtils';
import {CashierType, SupplierType} from '../../types/CashierSliceStateType';
import {useGetLogisticListQuery} from '../../redux/DepotSlice/depotCashierApi';
import CreateLinkButtons from './components/CreateLinkButtons';
import useClickMoreButton from '../../hooks/useClickMoreButton';
import {useStatusRestriction} from '../../hooks/useStatusRestriction';
import StatusRestrictionMessage from '../../Components/StatusRestrictionMessage/StatusRestrictionMessage';

export type FilterId = 'today' | 'yesterday' | 'drafts' | 'all';

const PaperworkList = () => {
	const {t} = useTranslation();
	const location = useLocation();
	const navigate = useNavigate();
	const restrictions = useStatusRestriction();
	const [currentCashier, setCurrentCashier] = useState<CashierType | null>(
		null,
	);
	const [filterMenu, setFilterMenu] = useState(false);

	const defaultFilterValues = {
		filter_active: false,
		offset: 0,
	};

	const [filters, setFilters] = useState<any>(defaultFilterValues);
	const {handleClickMoreButton} = useClickMoreButton(setFilters);
	const {data: paperworkList, isLoading} = usePaperworkListQuery(filters, {
		skip: !restrictions.canAccessWarehouseSection,
	});
	const {data: historyList, isLoading: isLoadingHistory} =
		usePaperworkHistoryQuery(filters, {
			skip: !restrictions.canAccessWarehouseSection,
		});
	const {data: suppliersList} = useGetLogisticListQuery(undefined, {
		skip: !restrictions.canAccessWarehouseSection,
	});

	if (!restrictions.canAccessWarehouseSection) {
		return (
			<div className="page__content">
				<StatusRestrictionMessage message={t('Сторінка недоступна')} />
			</div>
		);
	}

	const handleClickFilterButton = (id: FilterId) => {
		switch (id) {
			case 'today':
				setFilters({
					...defaultFilterValues,
					filter_active: true,
					from_date: todayDate(),
					to_date: todayDate(),
					offset: 0,
				});
				break;
			case 'yesterday':
				setFilters({
					...defaultFilterValues,
					filter_active: true,
					from_date: yesterdayDate(),
					to_date: yesterdayDate(),
					offset: 0,
				});
				break;
			case 'drafts':
				setFilters({
					...defaultFilterValues,
					filter_active: true,
					status_delivery: 'created',
					offset: 0,
				});
				break;
			case 'all':
				setFilters({
					...defaultFilterValues,
					filter_active: false,
					offset: 0,
				});
				break;
			default:
				break;
		}
	};
	const handleSubmitListForm = (values: RequestPaperworkListType) => {
		const filteredValues = submitFilterFieldCleaner(values);
		setFilters({
			...filteredValues,
			offset: 0,
		});
		setFilterMenu(false);
		scrollToTop('smooth');
	};

	const handleCancelFilter = () => {
		setFilters({
			...defaultFilterValues,
			offset: 0,
		});
		setFilterMenu(false);
		scrollToTop('smooth');
	};

	const handleLoadMore = () => {
		setFilters((prev: any) => ({
			...prev,
			offset: prev?.offset + 10,
		}));
	};

	const handleLoadMoreHistory = () => {
		setFilters((prev: any) => ({
			...prev,
			history_offset: prev?.offset + 10,
		}));
	};
	const filterButtons: FilterPaperworkButton[] = [
		{
			name: t('сьогодні'),
			id: 'today',
			active: filters.from_date === todayDate(),
		},
		{
			name: t('вчора'),
			id: 'yesterday',
			active: filters.from_date === yesterdayDate(),
		},
		{
			name: t('чернетки'),
			id: 'drafts',
			active: filters.status_delivery === 'created',
		},
		{
			name: t('всі'),
			id: 'all',
			active: !filters.filter_active,
		},
	].map((filter: any) => ({
		...filter,
		callback: () => handleClickFilterButton(filter.id),
	}));
	const initialListFormValues: RequestPaperworkListType = {
		filter_active: 1,
		from_date: '',
		to_date: '',
		status_delivery: '',
		order_id: '',
		client_name: '',
	};
	const tableHeadTitles = [
		'',
		'№',
		t('дата'),
		t("ім'я, контракт"),
		t('чек'),
		`возв.${t('чек')}`,
		t('оплата'),
		t('Статус'),
		t('Дії'),
	];

	useEffect(() => {
		if (location.state?.defaultFilters) {
			setFilters({
				...defaultFilterValues,
				...location.state.defaultFilters,
			});
			// чистим state после первого рендера
			setTimeout(() => {
				navigate(location.pathname, {replace: true});
			}, 0);
		} else {
			setFilters(defaultFilterValues);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<div className="page__content">
			<TopTitleBlock title={t('список оформлень')} />
			{suppliersList &&
				suppliersList?.suppliers?.map((supplier: SupplierType) => (
					<div key={supplier.supplier_id}>
						<div className={s.supplierName}>{supplier.supplier_name}</div>
						<PrroBlock
							supplier={supplier}
							currentCashier={currentCashier}
							setCurrentCashier={setCurrentCashier}
						/>
					</div>
				))}
			<CreateLinkButtons />
			<Formik
				validationSchema={validationFilterForm}
				initialValues={initialListFormValues}
				onSubmit={handleSubmitListForm}
			>
				{({handleSubmit}) => {
					return (
						<Form onSubmit={handleSubmit}>
							<PaperworkFilterButtons buttons={filterButtons} />
							<div className={s.filterButtonWrapper}>
								<AddFilterButton
									filterMenu={filterMenu}
									color={'blue'}
									setFilterMenu={setFilterMenu}
								/>
								<PaperWorkFilter
									active={filterMenu}
									onCancelFilter={handleCancelFilter}
								/>
							</div>
						</Form>
					);
				}}
			</Formik>
			{paperworkList?.orders && paperworkList.orders.length > 0 ? (
				<>
					<div className={s.tableScrollWrapper}>
						<div className={styleTableGrid.tableGrid}>
							<GridTableHead
								columns={tableHeadTitles}
								gridTemplateColumns="1fr 1.5fr 2fr 4fr 1fr 1fr 1fr 2fr 2fr"
								customClassName={s.tableRowPaperwork}
							/>
							{paperworkList.orders.map((order: OrderInPaperworkType) => (
								<PaperworkListTableElement
									currentCashier={currentCashier}
									order={order}
									key={order.id}
								/>
							))}
						</div>
					</div>
					{paperworkList?.orders && paperworkList.orders.length >= 10 && (
						<div className={s.buttonWrapper}>
							<LightGreenButton
								type={'button'}
								text={t('дивитися більше')}
								onClick={handleLoadMore}
							/>
						</div>
					)}
					<div className={s.totalWrapper}>
						<ShoppingTotal
							currency={paperworkList?.currency}
							sumMoney={paperworkList?.sum_money}
							sumBonuses={paperworkList?.sum_points}
							count={paperworkList?.count}
						/>
					</div>
				</>
			) : (
				<div className={s.emptyListContainer}>
					<div className={s.emptyListText}>
						{paperworkList?.message?.textmsg ||
							t('По заданим параметрам оформлення відсутні')}
					</div>
				</div>
			)}
			{paperworkList?.orders &&
				paperworkList.orders.length > 0 &&
				(isLoadingHistory ? (
					<PreLoaderComponent type={'category'} size={'medium'} />
				) : historyList && historyList?.actions?.length > 0 ? (
					<HistoryOfChangesInvoice
						ordersHistory={historyList.actions}
						onLoadMore={handleLoadMoreHistory}
						hasMore={historyList?.actions && historyList.actions.length >= 10}
					/>
				) : (
					<div className={s.emptyListContainer}>
						<div className={s.emptyListText}>
							{t('По обраним оформленням зміни відсутні')}
						</div>
					</div>
				))}
		</div>
	);
};

export default PaperworkList;
